import CryptoJS from "crypto-js";
// const key = "pzxifH9QU7I5tF8NDWBcXZxcCKvTbYNeFquXg231j8A5aJK7x0JaphjxGgnSR39s";
const key = "pzxifH9QU7I5tF8NDWBcXZxcCKvTbYNeFquXg231j8A5aJK7x0JaphjxGgnSR39s";
export const encrypt = (value) => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(value),
    process.env.REACT_APP_PRIVATE_KEY
  )
    .toString()
    .replaceAll("/", "int");
};

export const decrypt = (value) => {
  return CryptoJS.AES.decrypt(
    value.replaceAll("int", "/"),
    process.env.REACT_APP_PRIVATE_KEY
  ).toString(CryptoJS.enc.Utf8);
};

export const decryptData = (res, url) => {
  // Handle undefined, null, or non-string values
  if (!res || typeof res !== 'string') {
    // If res is an object (unencrypted response), return it as-is
    if (res && typeof res === 'object') {
      return res;
    }
    // If res is undefined/null, return undefined
    return res;
  }
  
  let decryptedRes = "";
  for (let i = 0; i < res.length; i += 2) {
    // Parse two characters at a time as hexadecimal and XOR with the key
    const encryptedByte = parseInt(res.substr(i, 2), 16);
    decryptedRes += String.fromCharCode(
      encryptedByte ^ key.charCodeAt((i / 2) % key.length)
    );
  }
  if (
    url &&
    (url === "/auth/api/v1/generate/sample/csv/" ||
      url.split("?")[0] === "/deephire/api/v1/download/report/" ||
      url.split("?")[0] === "/auth/api/v1/generate/failed/records/" ||
      url.split("?")[0] === "/deephire/api/v1/resend/register/link/")
  ) {
    return decryptedRes;
  } else {
    return JSON.parse(decryptedRes);
  }
};

export const encryptData = (jsonObject) => {
  const jsonString = JSON.stringify(jsonObject);
  let encryptedRed = "";
  for (let i = 0; i < jsonString.length; i++) {
    // XOR each character of JSON string with corresponding character of key
    encryptedRed += (jsonString.charCodeAt(i) ^ key.charCodeAt(i % key.length))
      .toString(16)
      .padStart(2, "0");
  }
  return encryptedRed;
};
